import type {ToolpanelType} from '../../types/ToolpanelType';
import {selectActivePanel} from '../createEagGridStore';
import {useEagGridSelector} from '../useEagGridSelector';

export function useActivePanel(): ToolpanelType | null {
  return useEagGridSelector(selectActivePanel);
}
